var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeHouses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "340px",
    height: "70px",
    viewBox: "0 0 340 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.166282411 0.274660453 320.195083 0.274660453 320.195083 66.969319 0.166282411 66.969319"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "p-01-One-Commercial-Homepage-AS-Style",
    transform: "translate(-675.000000, -219.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F0F2F5",
    x: 0,
    y: 0,
    width: 1440,
    height: 1159
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 250,
    y: 68,
    width: 1190,
    height: 919
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(675.000000, 219.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Businesses",
    transform: "translate(14.983051, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-97",
    transform: "translate(0.000000, 0.275761)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#F37722",
    mask: "url(#mask-2)",
    points: "69.6217463 66.9692639 125.091049 66.9692639 125.091049 27.0091953 69.6217463 27.0091953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.266253,43.8214423 C117.272858,43.9095098 117.26185,43.9931739 117.24974,44.0773885 L117.30203,43.9948252 C117.289921,43.9375813 117.270106,43.8814383 117.266253,43.8214423",
    id: "Fill-3",
    fill: "#D5E8F2",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "105.679325 65.649903 119.060078 65.649903 119.060078 32.5112111 105.679325 32.5112111"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#C45727",
    mask: "url(#mask-2)",
    points: "126.109549 27.0090852 68.6036863 27.0090852 77.2557658 13.8650138 117.45857 13.8650138"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#F37722",
    mask: "url(#mask-2)",
    points: "67.0773117 40.67958 64.620229 39.627724 63.0063924 39.627724 63.0063924 39.9893511 67.0773117 41.7308855"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#F1F1F1",
    mask: "url(#mask-2)",
    points: "67.0773117 41.7309956 63.0063924 39.9889107 63.0063924 41.0407667 67.0773117 42.7828515"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#F1F1F1",
    mask: "url(#mask-2)",
    points: "67.0773117 40.67958 67.0773117 39.627724 64.620229 39.627724"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#F37722",
    mask: "url(#mask-2)",
    points: "67.0773117 42.7826864 63.0063924 41.0406016 63.0063924 42.0924575 67.0773117 43.833992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#F1F1F1",
    mask: "url(#mask-2)",
    points: "63.0061723 42.0919622 63.0061723 43.1438181 67.0770915 44.8864534 67.0770915 43.8345974"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#F37722",
    mask: "url(#mask-2)",
    points: "63.0061723 44.1952888 67.0770915 45.9379241 67.0770915 44.8860681 63.0061723 43.1434328"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#F1F1F1",
    mask: "url(#mask-2)",
    points: "63.0061723 45.2469246 67.0770915 46.9895599 67.0770915 45.9377039 63.0061723 44.1950686"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#F1F1F1",
    mask: "url(#mask-2)",
    points: "63.0061723 46.2985604 63.0061723 47.3504164 65.4638054 47.3504164"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#F37722",
    mask: "url(#mask-2)",
    points: "63.0061723 46.2985604 65.4638054 47.3504164 67.0770915 47.3504164 67.0770915 46.9893397 63.0061723 45.2467044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0773117,39.6279442 C67.2182197,39.6279442 67.3316066,39.5112547 67.3316066,39.3648426 C67.3316066,39.2200816 67.2182197,39.101741 67.0773117,39.101741 L66.3138767,39.101741 C66.3138767,38.5557226 65.9907792,38.0873137 65.5306266,37.8891618 C65.5372317,37.8550357 65.5504418,37.8242121 65.5504418,37.7878842 C65.5504418,37.4972616 65.3225672,37.2622315 65.0413017,37.2622315 C64.7605866,37.2622315 64.532712,37.4972616 64.532712,37.7878842 C64.532712,37.8242121 64.5459221,37.8555861 64.5525271,37.8891618 C64.3395139,37.9810823 64.159526,38.1324483 64.0235718,38.3217933 C63.8656008,38.5403108 63.769277,38.8083662 63.769277,39.101741 L63.3911373,39.101741 L63.0063924,39.101741 C62.8654845,39.101741 62.7520976,39.2200816 62.7520976,39.3648426 C62.7520976,39.5112547 62.8654845,39.6279442 63.0063924,39.6279442 L64.620229,39.6279442 L67.0773117,39.6279442 Z",
    id: "Fill-15",
    fill: "#6D6E71",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0061723,47.349976 C62.8658147,47.349976 62.7524279,47.4677663 62.7524279,47.6130776 C62.7524279,47.7578385 62.8658147,47.8761792 63.0061723,47.8761792 L64.235264,47.8761792 L66.6923467,47.8761792 L67.0770915,47.8761792 C67.2179995,47.8761792 67.3319368,47.7578385 67.3319368,47.6130776 C67.3319368,47.4677663 67.2179995,47.349976 67.0770915,47.349976 L65.4638054,47.349976 L63.0061723,47.349976 Z",
    id: "Fill-16",
    fill: "#6D6E71",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2362548,47.8762343 L63.7694972,47.8762343 C63.7694972,48.4233535 64.0925947,48.8917624 64.5527473,49.0893638 C64.5461423,49.1234899 64.5329321,49.154864 64.5329321,49.1911918 C64.5329321,49.4818145 64.7608067,49.7162942 65.0415218,49.7162942 C65.3227873,49.7162942 65.5512124,49.4818145 65.5512124,49.1911918 C65.5512124,49.154864 65.5380022,49.1234899 65.5308468,49.0893638 C65.74386,48.9979938 65.9238479,48.845527 66.0603525,48.6572827 C66.2177731,48.4387653 66.3140969,48.1701595 66.3140969,47.8762343 L64.2362548,47.8762343 Z",
    id: "Fill-17",
    fill: "#6D6E71",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#6D6E71",
    mask: "url(#mask-2)",
    points: "67.0765962 41.7307754 69.6217463 41.7307754 69.6217463 40.6794699 67.0765962 40.6794699"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#6D6E71",
    mask: "url(#mask-2)",
    points: "67.0765962 45.9370984 69.6217463 45.9370984 69.6217463 44.8857929 67.0765962 44.8857929"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "75.1309176 56.0560519 99.6202821 56.0560519 99.6202821 32.5112111 75.1309176 32.5112111"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#6D80BA",
    mask: "url(#mask-2)",
    points: "3.02126499 66.9687135 60.1115593 66.9687135 60.1115593 25.8637676 3.02126499 25.8637676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.111064,59.1340654 L3.02076961,59.1340654 C1.44381129,59.1340654 0.166282411,59.8655759 0.166282411,60.7666163 L0.166282411,66.969319 L62.9661016,66.969319 L62.9661016,60.7666163 C62.9661016,59.8655759 61.6874718,59.1340654 60.111064,59.1340654",
    id: "Fill-22",
    fill: "#6D80BA",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72968896,28.7178695 C7.15328107,28.7178695 5.87575218,27.4397902 5.87575218,25.8633823 L5.87575218,19.5836206 L11.5847266,19.5836206 L11.5847266,25.8633823 C11.5847266,27.4397902 10.3066473,28.7178695 8.72968896,28.7178695",
    id: "Fill-23",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1476928,28.7178695 C18.5712849,28.7178695 17.293756,27.4397902 17.293756,25.8633823 L17.293756,19.5836206 L23.0027304,19.5836206 L23.0027304,25.8633823 C23.0027304,27.4397902 21.7241007,28.7178695 20.1476928,28.7178695",
    id: "Fill-24",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5657517,28.7178695 C29.9893438,28.7178695 28.7118149,27.4397902 28.7118149,25.8633823 L28.7118149,19.5836206 L34.4207893,19.5836206 L34.4207893,25.8633823 C34.4207893,27.4397902 33.14271,28.7178695 31.5657517,28.7178695",
    id: "Fill-25",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9837555,28.7178695 C41.4073476,28.7178695 40.1298187,27.4397902 40.1298187,25.8633823 L40.1298187,19.5836206 L45.8382427,19.5836206 L45.8382427,25.8633823 C45.8382427,27.4397902 44.5607138,28.7178695 42.9837555,28.7178695",
    id: "Fill-26",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4017593,28.7178695 C52.8253514,28.7178695 51.5478225,27.4397902 51.5478225,25.8633823 L51.5478225,19.5836206 L57.2562465,19.5836206 L57.2562465,25.8633823 C57.2562465,27.4397902 55.9787176,28.7178695 54.4017593,28.7178695",
    id: "Fill-27",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "29.226184 11.5908363 28.7115397 19.5835105 34.4205141 19.5835105 33.9053193 11.5908363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "19.738124 11.5908363 17.2931505 19.5835105 23.0026754 19.5835105 24.4827594 11.5908363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "10.2506143 11.5908363 5.87586227 19.5835105 11.5837358 19.5835105 14.994149 11.5908363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "38.6491842 11.5908363 40.1292683 19.5835105 45.8382427 19.5835105 43.3938197 11.5908363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "48.1372442 11.5908363 51.5476574 19.5835105 57.2566318 19.5835105 52.8807789 11.5908363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02065952,28.7178695 C1.44425163,28.7178695 0.166722748,27.4397902 0.166722748,25.8633823 L0.166722748,19.5836206 L5.87569714,19.5836206 L5.87569714,25.8633823 C5.87569714,27.4397902 4.59761784,28.7178695 3.02065952,28.7178695",
    id: "Fill-33",
    fill: "#0457A2",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4386634,28.7178695 C12.8622555,28.7178695 11.5847266,27.4397902 11.5847266,25.8633823 L11.5847266,19.5836206 L17.2931505,19.5836206 L17.2931505,25.8633823 C17.2931505,27.4397902 16.0156217,28.7178695 14.4386634,28.7178695",
    id: "Fill-34",
    fill: "#0457A2",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8567222,28.7178695 C24.2803143,28.7178695 23.0027854,27.4397902 23.0027854,25.8633823 L23.0027854,19.5836206 L28.7112094,19.5836206 L28.7112094,25.8633823 C28.7112094,27.4397902 27.4331301,28.7178695 25.8567222,28.7178695",
    id: "Fill-35",
    fill: "#0457A2",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.274726,28.7178695 C35.6983182,28.7178695 34.4207893,27.4397902 34.4207893,25.8633823 L34.4207893,19.5836206 L40.1297637,19.5836206 L40.1297637,25.8633823 C40.1297637,27.4397902 38.8511339,28.7178695 37.274726,28.7178695",
    id: "Fill-36",
    fill: "#0457A2",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6927849,28.7178695 C47.116377,28.7178695 45.8388481,27.4397902 45.8388481,25.8633823 L45.8388481,19.5836206 L51.5478225,19.5836206 L51.5478225,25.8633823 C51.5478225,27.4397902 50.2697432,28.7178695 48.6927849,28.7178695",
    id: "Fill-37",
    fill: "#0457A2",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#0457A2",
    mask: "url(#mask-2)",
    points: "14.9944792 11.5908363 11.5846165 19.5835105 17.2935909 19.5835105 19.7380139 11.5908363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#0457A2",
    mask: "url(#mask-2)",
    points: "5.5066944 11.5908363 0.166502579 19.5835105 5.87492655 19.5835105 10.250229 11.5908363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#0457A2",
    mask: "url(#mask-2)",
    points: "24.4822641 11.5908363 23.00218 19.5835105 28.7111544 19.5835105 29.2257987 11.5908363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#0457A2",
    mask: "url(#mask-2)",
    points: "52.880889 11.5908363 57.2561915 19.5835105 62.9651659 19.5835105 57.624974 11.5908363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#0457A2",
    mask: "url(#mask-2)",
    points: "33.9053193 11.5908363 34.4205141 19.5835105 40.1294885 19.5835105 38.6494044 11.5908363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#0457A2",
    mask: "url(#mask-2)",
    points: "43.3931041 11.5908363 45.838628 19.5835105 51.5476024 19.5835105 48.1371892 11.5908363"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "42.412748 64.1136759 56.1143966 64.1136759 56.1143966 33.2851041 42.412748 33.2851041"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "9.99510856 57.1805635 34.4844731 57.1805635 34.4844731 33.6357227 9.99510856 33.6357227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1050508,39.8443149 C49.0945928,39.9131177 49.1204626,39.7760626 49.1050508,39.8443149",
    id: "Fill-46",
    fill: "#C68476",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2347834,48.6896163 C47.2227834,48.5686163 47.2217834,48.4106163 47.2317834,48.2196163 C47.2217834,48.4106163 47.2227834,48.5686163 47.2347834,48.6896163",
    id: "Fill-47",
    fill: "#296E7D",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1958018,44.0622519 C38.1071839,44.0435375 38.014713,44.0347308 37.9277464,44.0314282 C38.014713,44.0347308 38.1071839,44.0435375 38.1958018,44.0622519",
    id: "Fill-48",
    fill: "#AA2F27",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0509921,42.5832136 C38.9887944,42.5430328 38.9287984,42.5094571 38.8787101,42.4835872 C38.9287984,42.5094571 38.9887944,42.5430328 39.0509921,42.5832136",
    id: "Fill-49",
    fill: "#82963A",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3713625,43.4186716 C43.5343625,43.2136716 43.6023625,42.9416716 43.6143625,42.6606716 C43.6023625,42.9416716 43.5353625,43.2136716 43.3713625,43.4186716",
    id: "Fill-50",
    fill: "#A78051",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8497449,49.0938544 C47.7727449,49.0118544 47.7047449,48.9438544 47.6487449,48.8878544 C47.7047449,48.9438544 47.7727449,49.0118544 47.8497449,49.0938544",
    id: "Fill-51",
    fill: "#569095",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5554848,52.8934386 C44.5450268,52.9242622 44.5312662,52.9594892 44.5164048,52.9991196 L44.5268629,53.0266407 C44.5389721,52.9798548 44.5494302,52.9380228 44.5598882,52.9027958 L44.5554848,52.8934386",
    id: "Fill-52",
    fill: "#763A2A",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.929734,46.1567835 C40.033734,45.9967835 40.111734,45.8477835 40.165734,45.7087835 C40.111734,45.8477835 40.033734,45.9967835 39.929734,46.1567835",
    id: "Fill-53",
    fill: "#82963A",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0693444,45.9103484 C41.1613444,45.8203484 41.2293444,45.7263484 41.2773444,45.6303484 C41.2293444,45.7263484 41.1613444,45.8203484 41.0693444,45.9103484",
    id: "Fill-54",
    fill: "#82963A",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1725927,45.9318045 C41.2745927,45.7268045 41.2825927,45.5118045 41.2255927,45.3028045 C41.2825927,45.5118045 41.2745927,45.7268045 41.1725927,45.9318045",
    id: "Fill-55",
    fill: "#8EA840",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7937395,44.4089445 C42.9599286,44.3339445 43.0688111,44.2369445 43.1328035,44.1309445 C43.0688111,44.2369445 42.9599286,44.3339445 42.7937395,44.4089445",
    id: "Fill-56",
    fill: "#82963A",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5582732,43.6169056 C41.5720338,43.5822291 41.587996,43.5464516 41.6050591,43.5112246 L41.6050591,43.5117751 C41.587996,43.5464516 41.5720338,43.5822291 41.5582732,43.6169056",
    id: "Fill-57",
    fill: "#CF4936",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3276528,44.5569847 C42.4596528,44.5289847 42.5726528,44.4929847 42.6656528,44.4519847 C42.5726528,44.4929847 42.4596528,44.5289847 42.3276528,44.5569847",
    id: "Fill-58",
    fill: "#8EA840",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-59",
    fill: "#CF4936",
    mask: "url(#mask-2)",
    points: "42.7341943 44.1486693 42.7341943 44.1486693 42.7651943 44.0036693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0932312,45.0777149 C42.1455361,45.0437149 42.1996142,45.0057149 42.2528056,44.9637149 L42.26699,44.9537149 L42.2528056,44.9637149 C42.1996142,45.0057149 42.1455361,45.0437149 42.0932312,45.0777149 M41.2856071,45.3797149 C41.444295,45.3777149 41.6260326,45.3297149 41.8228411,45.2347149 C41.6260326,45.3297149 41.444295,45.3777149 41.2856071,45.3797149",
    id: "Fill-60",
    fill: "#82963A",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6119944,45.1079981 C41.6659357,45.0854309 41.7220787,45.0568089 41.779873,45.0215819 C41.7220787,45.0568089 41.6659357,45.0854309 41.6119944,45.1079981",
    id: "Fill-61",
    fill: "#8EA840",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2069208,45.0835361 L42.2069208,45.0825873 C42.3769208,44.8548833 42.3919208,44.6110503 42.3219208,44.3729099 L42.3229208,44.3729099 C42.3919208,44.6110503 42.3769208,44.8548833 42.2069208,45.0835361",
    id: "Fill-62",
    fill: "#82963A",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9369634,44.9166165 C41.9898039,44.874234 42.0316359,44.8302003 42.0635604,44.7850657 C42.0316359,44.8302003 41.9898039,44.874234 41.9369634,44.9166165",
    id: "Fill-63",
    fill: "#8EA840",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1908734,44.524693 C42.1608734,44.416693 42.1148734,44.308693 42.0588734,44.205693 C42.1148734,44.308693 42.1608734,44.416693 42.1908734,44.524693",
    id: "Fill-64",
    fill: "#AA2F27",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1113392,28.7178695 C58.5349313,28.7178695 57.2563015,27.4397902 57.2563015,25.8633823 L57.2563015,19.5836206 L62.9652759,19.5836206 L62.9652759,25.8633823 C62.9652759,27.4397902 61.6877471,28.7178695 60.1113392,28.7178695",
    id: "Fill-65",
    fill: "#0457A2",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-66",
    fill: "#0455A4",
    mask: "url(#mask-2)",
    points: "204.728269 66.9692639 316.946054 66.9692639 316.946054 19.3913583 204.728269 19.3913583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.355518,38.8313188 C256.363223,38.9381006 256.350013,39.040479 256.335702,39.142307 L256.399001,39.0426807 C256.384139,38.9722267 256.361022,38.903424 256.355518,38.8313188",
    id: "Fill-67",
    fill: "#D5E8F2",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-68",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "212.761675 58.6782611 244.434593 58.6782611 244.434593 31.4687123 212.761675 31.4687123"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-69",
    fill: "#15385F",
    mask: "url(#mask-2)",
    points: "309.333611 3.39984507 320.195083 19.3780381 201.34912 19.3780381 212.211693 3.39984507"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#4F494A",
    mask: "url(#mask-2)",
    points: "226.439215 49.9795058 226.38142 49.9795058 226.348395 49.947031 226.348395 49.8787787 226.38142 49.8468542 226.439215 49.8468542 226.47169 49.8787787 226.47169 49.947031"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-71",
    fill: "#4F494A",
    mask: "url(#mask-2)",
    points: "226.275795 49.9795058 226.21745 49.9795058 226.184975 49.947031 226.184975 49.8787787 226.21745 49.8468542 226.275795 49.8468542 226.308269 49.8787787 226.308269 49.947031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.966298,43.9213989 L220.567591,43.9213989",
    id: "Fill-72",
    fill: "#E9D1B6",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-73",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "278.42754 58.6782611 310.100459 58.6782611 310.100459 31.4687123 278.42754 31.4687123"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-74",
    fill: "#70963E",
    mask: "url(#mask-2)",
    points: "131.736015 15.0952064 131.736015 66.9691538 175.781314 66.9691538 191.165602 66.9691538 196.80082 66.9691538 196.80082 15.0952064"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-75",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "137.910922 57.0016764 169.553017 57.0016764 169.553017 33.4568357 137.910922 33.4568357"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    fill: "#557133",
    mask: "url(#mask-2)",
    points: "138.940981 29.3492033 134.656498 29.3492033 133.891412 39.9607842 138.345975 39.9607842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.34592,39.9606741 L133.891357,39.9606741 C133.875394,40.1890991 133.92218,40.4070661 134.020706,40.6063188 C134.119231,40.8050211 134.270597,40.9839081 134.462144,41.1358245 C134.654241,41.2860897 134.88707,41.4088337 135.14907,41.4935987 C135.411071,41.5789141 135.702795,41.6245991 136.012132,41.6245991 C136.321469,41.6245991 136.618696,41.5789141 136.891706,41.4935987 C137.164715,41.4088337 137.413505,41.2860897 137.624867,41.1358245 C137.836229,40.9839081 138.009612,40.8050211 138.134008,40.6063188 C138.258403,40.4070661 138.33326,40.1890991 138.34592,39.9606741",
    id: "Fill-77",
    fill: "#557133",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-78",
    fill: "#DBDCDD",
    mask: "url(#mask-2)",
    points: "143.225299 29.3492033 138.940816 29.3492033 138.34636 39.9607842 142.800373 39.9607842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.799823,39.9606741 L138.34581,39.9606741 C138.33315,40.1890991 138.383239,40.4070661 138.485067,40.6063188 C138.587445,40.8050211 138.741013,40.9839081 138.935312,41.1358245 C139.130161,41.2860897 139.36464,41.4088337 139.627742,41.4935987 C139.891945,41.5789141 140.183668,41.6245991 140.493005,41.6245991 C140.802342,41.6245991 141.099019,41.5789141 141.371478,41.4935987 C141.641735,41.4088337 141.888875,41.2860897 142.097484,41.1358245 C142.306645,40.9839081 142.477826,40.8050211 142.598919,40.6063188 C142.720011,40.4070661 142.791016,40.1890991 142.799823,39.9606741",
    id: "Fill-79",
    fill: "#DBDCDD",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-80",
    fill: "#557133",
    mask: "url(#mask-2)",
    points: "147.509341 29.3492033 143.224858 29.3492033 142.799933 39.9607842 147.255046 39.9607842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.254826,39.9606741 L142.799713,39.9606741 C142.791456,40.1890991 142.845398,40.4070661 142.950528,40.6063188 C143.055108,40.8050211 143.211978,40.9839081 143.408479,41.1358245 C143.60553,41.2860897 143.842211,41.4088337 144.106414,41.4935987 C144.371717,41.5789141 144.665092,41.6245991 144.974429,41.6245991 C145.283215,41.6245991 145.578792,41.5789141 145.849599,41.4935987 C146.119857,41.4088337 146.364794,41.2860897 146.571202,41.1358245 C146.777611,40.9839081 146.945489,40.8050211 147.063279,40.6063188 C147.18107,40.4070661 147.248772,40.1890991 147.254826,39.9606741",
    id: "Fill-81",
    fill: "#557133",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-82",
    fill: "#DBDCDD",
    mask: "url(#mask-2)",
    points: "151.793659 29.3492033 147.509176 29.3492033 147.254881 39.9607842 151.708894 39.9607842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.708729,39.9606741 L147.254716,39.9606741 C147.248661,40.1890991 147.305355,40.4070661 147.414338,40.6063188 C147.522772,40.8050211 147.682944,40.9839081 147.881096,41.1358245 C148.080899,41.2860897 148.319782,41.4088337 148.585636,41.4935987 C148.85204,41.5789141 149.145965,41.6245991 149.455302,41.6245991 C149.764639,41.6245991 150.059665,41.5789141 150.328271,41.4935987 C150.597427,41.4088337 150.840163,41.2860897 151.043819,41.1358245 C151.247475,40.9839081 151.413152,40.8050211 151.52764,40.6063188 C151.642678,40.4070661 151.706527,40.1890991 151.708729,39.9606741",
    id: "Fill-83",
    fill: "#DBDCDD",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-84",
    fill: "#557133",
    mask: "url(#mask-2)",
    points: "156.077702 29.3492033 151.793219 29.3492033 151.709004 39.9607842 156.162467 39.9607842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.16294,39.9606741 L151.708344,39.9606741 C151.706142,40.1890991 151.767239,40.4070661 151.878424,40.6063188 C151.99126,40.8050211 152.152534,40.9839081 152.354539,41.1358245 C152.555993,41.2860897 152.797628,41.4088337 153.064583,41.4935987 C153.332088,41.5789141 153.627114,41.6245991 153.936451,41.6245991 C154.245237,41.6245991 154.539713,41.5789141 154.807769,41.4935987 C155.074723,41.4088337 155.315257,41.2860897 155.517262,41.1358245 C155.718166,40.9839081 155.881641,40.8050211 155.992276,40.6063188 C156.105113,40.4070661 156.164558,40.1890991 156.16294,39.9606741",
    id: "Fill-85",
    fill: "#557133",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-86",
    fill: "#DBDCDD",
    mask: "url(#mask-2)",
    points: "160.362019 29.3492033 156.077536 29.3492033 156.163402 39.9607842 160.617415 39.9607842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.617305,39.9606741 L156.163292,39.9606741 C156.164943,40.1890991 156.229343,40.4070661 156.34328,40.6063188 C156.458318,40.8050211 156.623995,40.9839081 156.828202,41.1358245 C157.032408,41.2860897 157.274043,41.4088337 157.54375,41.4935987 C157.812356,41.5789141 158.107382,41.6245991 158.416719,41.6245991 C158.726056,41.6245991 159.019431,41.5789141 159.286385,41.4935987 C159.551688,41.4088337 159.790571,41.2860897 159.989824,41.1358245 C160.189077,40.9839081 160.34925,40.8050211 160.457132,40.6063188 C160.565015,40.4070661 160.622259,40.1890991 160.617305,39.9606741",
    id: "Fill-87",
    fill: "#DBDCDD",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-88",
    fill: "#557133",
    mask: "url(#mask-2)",
    points: "164.646832 29.3492033 160.361799 29.3492033 160.617745 39.9607842 165.071208 39.9607842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.070932,39.9606741 L160.61692,39.9606741 C160.621873,40.1890991 160.690676,40.4070661 160.808466,40.6063188 C160.926807,40.8050211 161.094686,40.9839081 161.300543,41.1358245 C161.506952,41.2860897 161.751889,41.4088337 162.022146,41.4935987 C162.292403,41.5789141 162.58798,41.6245991 162.897867,41.6245991 C163.206654,41.6245991 163.500029,41.5789141 163.764782,41.4935987 C164.028984,41.4088337 164.266216,41.2860897 164.463267,41.1358245 C164.660318,40.9839081 164.816638,40.8050211 164.921768,40.6063188 C165.027449,40.4070661 165.08084,40.1890991 165.070932,39.9606741",
    id: "Fill-89",
    fill: "#557133",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-90",
    fill: "#DBDCDD",
    mask: "url(#mask-2)",
    points: "168.93038 29.3492033 164.646998 29.3492033 165.071373 39.9607842 169.525936 39.9607842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.525936,39.9606741 L165.070822,39.9606741 C165.08073,40.1890991 165.151734,40.4070661 165.272277,40.6063188 C165.39337,40.8050211 165.565101,40.9839081 165.773711,41.1358245 C165.982871,41.2860897 166.22946,41.4088337 166.500818,41.4935987 C166.772726,41.5789141 167.069404,41.6245991 167.378741,41.6245991 C167.688078,41.6245991 167.979801,41.5789141 168.243453,41.4935987 C168.507105,41.4088337 168.741585,41.2860897 168.936985,41.1358245 C169.130733,40.9839081 169.284301,40.8050211 169.386129,40.6063188 C169.488507,40.4070661 169.538045,40.1890991 169.525936,39.9606741",
    id: "Fill-91",
    fill: "#DBDCDD",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-92",
    fill: "#557133",
    mask: "url(#mask-2)",
    points: "173.105274 29.3139763 168.821341 29.4025942 169.635415 39.9998641 174.088327 39.9079437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.979839,39.9606741 L169.525826,39.9606741 C169.538486,40.1890991 169.612793,40.4070661 169.737188,40.6063188 C169.861583,40.8050211 170.035516,40.9839081 170.246878,41.1358245 C170.45824,41.2860897 170.707031,41.4088337 170.98004,41.4935987 C171.253049,41.5789141 171.550277,41.6245991 171.859064,41.6245991 C172.168401,41.6245991 172.460124,41.5789141 172.722675,41.4935987 C172.983575,41.4088337 173.216954,41.2860897 173.409602,41.1358245 C173.601699,40.9839081 173.751964,40.8050211 173.85049,40.6063188 C173.949566,40.4070661 173.996902,40.1890991 173.979839,39.9606741",
    id: "Fill-93",
    fill: "#557133",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-94",
    fill: "#557133",
    mask: "url(#mask-2)",
    points: "199.362648 15.0952064 129.174518 15.0952064 137.884391 0.274550369 190.653324 0.274550369"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-95",
    fill: "#557133",
    mask: "url(#mask-2)",
    points: "191.677714 27.2695448 191.677714 27.2695448 136.859011 27.2695448 136.859011 17.2122385 191.677714 17.2122385"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-96",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "175.780488 64.9960019 190.0865 64.9960019 190.0865 33.4562852 175.780488 33.4562852"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-98",
    fill: "#FFFFFF",
    points: "252.316082 65.5150497 270.828417 65.5150497 270.828417 31.3311069 252.316082 31.3311069"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LIne",
    transform: "translate(0.000000, 67.423729)",
    stroke: "#C6C3C2",
    strokeWidth: 2.622
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.477571813 L339.63664,0.477571813",
    id: "Stroke-99"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHouses);
export default __webpack_public_path__ + "static/media/home-houses.538ad19862beb2ce75a89627f26967e8.svg";
export { ForwardRef as ReactComponent };